module.exports = __webpack_public_path__ + "static/media/draw-tutorial-2.dc8bb0a5.svg";